<template>
    <div>
        <PageTop></PageTop>
        <button
            class="bg-bd text-14 px-4 py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="$router.push({name:'userIndex'})"
            >
                返回
            </button>
        <div class="my-12 text-16"
        v-for="(item,index) in data" :key="index"
        
        >
            <div class="text-center">{{item?.joinin || item?.data?.[0]?.joinin}}</div>
            <div class="border-2 border-solid border-bd w-300 overflow-hidden mx-auto">
            <div class="flex justify-around w-300 bg-primary text-bg">
                <div class="text-center">第一场 12:00</div>
                <div class="text-center">第二场 20:00</div>
            </div>
            <div class="flex justify-around w-300 bg-bg text-primary">
                <div>
                    <div v-if="item?.data?.[1]?.times === 1">
                        {{ imgName?.[item?.data?.[1]?.result - 1] }}
                    </div>
                    <div v-else>
                        {{ imgName?.[item?.data?.[0]?.result - 1] }}
                    </div>
                </div>
                <div>
                    <div v-if="item?.data?.[0]?.times === 2">
                        {{ imgName?.[item?.data?.[0]?.result - 1] }}
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import PageTop from '@/components/PageTop.vue';

export default{
    components:{
        PageTop
    },
    data(){
        return{
            data:[],
            imgName: [
                '白鱼','白马','蝴蝶','金龙','野猫','和尚','鸡','金鱼','马鹿',
                '仙鹤','乌龟','乌鸦','大象','蜘蛛','蛇','孔雀','老虎','鹅',
                '红燕','猴子','猪','螺蛳','狗','兔子','飞龙','家猫','螃蟹',
                '牛','羊','蚯蚓','鸽子','青蛙','宝石','蜜蜂','黄鳝','老鼠'
            ],   
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
       async getData(){
            try{
                const res = await this.$axios.get('/user/history')
                console.log(res);
                this.data = res?.data?.data
            }catch(err){
                return err
            }
        }
    }
}
</script>
<style scoped>
</style>